import React from 'react'

import { MainLayout } from 'src/common/layouts/MainLayout/MainLayout'
import { StoryClientType } from 'src/strapi/types/storiesTypes'
import { AnalyticEventEnum } from 'src/utils/analytic/analyticEventEnum'
import { useAnalytic } from 'src/utils/analytic/useAnalytic'

import { AboutContactBlock } from './AboutContactBlock/AboutContactBlock'
import { AboutInfoBlock } from './AboutInfoBlock/AboutInfoBlock'
import { AboutNumbersBlock } from './AboutNumbersBlock/AboutNumbersBlock'
import { AboutSignupBlock } from './AboutSignupBlock/AboutSignupBlock'
import { AboutTrustedBlock } from './AboutTrustedBlock/AboutTrustedBlock'

import s from './AboutPage.module.scss'

export type AboutPageProps = {
  stories: Array<StoryClientType>
}

export const AboutPage: React.FC<AboutPageProps> = ({ stories }) => {
  const { analytic } = useAnalytic()
  analytic.event(AnalyticEventEnum.ABOUT_PAGE)

  return (
    <MainLayout pageAnalytic={'about'}>
      <AboutInfoBlock />
      <AboutNumbersBlock />

      <div className={s.AboutPage__backgroundGradient}>
        <AboutSignupBlock />
        <AboutTrustedBlock stories={stories} />
      </div>

      <AboutContactBlock />
    </MainLayout>
  )
}
